export type YandexApiResponse = {
  results?: YandexSuggestion[];
};

export type YandexSuggestion = {
  address?: {
    formatted_address?: string;
    component?: YandexAddressComponent[];
  };
};

export type YandexAddressComponent = {
  name?: string;
  kind?: string[];
};
